import script from "./O365LoginSucceeded.vue?vue&type=script&lang=ts&setup=true"
export * from "./O365LoginSucceeded.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__